import { format } from "date-fns";

import styles from "./BillingHeader.module.scss";

interface BillingHeaderProps {
  billedDate: number;
}

export const BillingHeader = ({ billedDate }: BillingHeaderProps) => {
  const nextBillingDate = `${format(
    new Date(billedDate * 1000),
    "MMMM dd',' yyyy",
  )}`;

  return (
    // @ts-expect-error TS2339 non-existing className
    <header className={styles.header}>
      <p className={styles.headerDescription}>
        This is a preview of the upcoming invoice estimate that will be billed
        on {nextBillingDate}. Note that final sum can change depending on your
        usage of pay as you go features
      </p>
    </header>
  );
};
